(function () {
  // Same conversion table as assets/size-unit-toggle.js (kept as an independent copy
  // deliberately, so this file has no load-order dependency on that one).
  var EU_TO_UK_US = {
    35: { uk: '2.5', us: '3.5' },
    36: { uk: '3.5', us: '4' },
    37: { uk: '4', us: '4.5' },
    38: { uk: '5', us: '5.5' },
    39: { uk: '6', us: '6.5' },
    39.5: { uk: '6.5', us: '7' },
    40: { uk: '6.5', us: '7' },
    40.5: { uk: '7', us: '7.5' },
    41: { uk: '7.5', us: '8' },
    42: { uk: '8', us: '8.5' },
    42.5: { uk: '8.5', us: '9' },
    43: { uk: '9', us: '9.5' },
    44: { uk: '9.5', us: '10' },
    45: { uk: '10.5', us: '11' },
    46: { uk: '11', us: '11.5' },
    47: { uk: '12', us: '13' },
    48: { uk: '13', us: '14' },
    49: { uk: '13.5', us: '14.5' },
    50: { uk: '14', us: '15' }
  };

  // Text-only: reads a <dt>/<dd> pair and rewrites the <dd> text content in place.
  // Deliberately does not move, clone, or reparent any element (see the 2026-09-15
  // incident where reordering size-picker inputs broke their CSS sibling styling and
  // click handling — this file avoids that class of bug entirely by never touching
  // element structure, only text).
  function annotateOption(optionRow) {
    var dt = optionRow.querySelector('dt');
    var dd = optionRow.querySelector('dd');
    if (!dt || !dd) return;
    if (!/size/i.test(dt.textContent)) return;
    if (dd.dataset.sizeAnnotated) return;

    var raw = dd.textContent.trim();
    var euSize = parseFloat(raw);
    if (isNaN(euSize)) return;

    var conversion = EU_TO_UK_US[euSize];
    if (!conversion) return;

    var unit = window.zunuciDefaultSizeUnit || 'EU';
    var localValue = unit === 'US' ? conversion.us : unit === 'UK' ? conversion.uk : null;
    if (!localValue) return;

    dd.dataset.sizeAnnotated = 'true';
    dd.textContent = raw + ' (' + unit + ' ' + localValue + ')';
  }

  function init() {
    document.querySelectorAll('.product-option').forEach(annotateOption);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Cart notification / cart page content is re-fetched and swapped in (innerHTML) on
  // every add-to-cart or quantity change, publishing this same pub/sub event that the
  // theme already uses elsewhere for post-cart-update refreshes (see product-info.js).
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      try {
        init();
      } catch (error) {
        console.error('cart-size-display:', error);
      }
    });
  }
})();
